/* MotherJoysMagic Theme JS */
const MJM = (function () {

  /* ── STARFIELD ── */
  function initStarfield() {
    const canvas = document.getElementById('hero-canvas');
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    let W, H, stars = [];

    function resize() {
      W = canvas.width  = canvas.offsetWidth;
      H = canvas.height = canvas.offsetHeight;
    }
    function init() {
      resize();
      stars = Array.from({ length: 140 }, () => ({
        x: Math.random() * W, y: Math.random() * H,
        r: Math.random() * 1.5 + .3,
        vy: Math.random() * .25 + .08,
        vx: (Math.random() - .5) * .25,
        op: Math.random() * .5 + .15,
        ts: Math.random() * .015 + .004,
        to: Math.random() * Math.PI * 2
      }));
    }
    let t = 0;
    function draw() {
      ctx.clearRect(0, 0, W, H); t += .016;
      stars.forEach(s => {
        s.y -= s.vy; s.x += s.vx;
        if (s.y < -4) { s.y = H + 4; s.x = Math.random() * W; }
        if (s.x < -4) s.x = W + 4;
        if (s.x > W + 4) s.x = -4;
        const a = s.op * (.65 + .35 * Math.sin(t * s.ts * 60 + s.to));
        ctx.beginPath();
        ctx.arc(s.x, s.y, s.r, 0, Math.PI * 2);
        ctx.fillStyle = `rgba(123,94,167,${a})`;
        ctx.fill();
      });
      requestAnimationFrame(draw);
    }
    window.addEventListener('resize', init);
    init(); draw();
  }

  /* ── CART DRAWER ── */
  function openCart() {
    document.getElementById('overlay').classList.add('open');
    document.getElementById('drawer').classList.add('open');
    fetchCart();
  }
  function closeCart() {
    document.getElementById('overlay').classList.remove('open');
    document.getElementById('drawer').classList.remove('open');
  }

  function fetchCart() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(renderCart)
      .catch(console.error);
  }

  function renderCart(cart) {
    const badge   = document.getElementById('cartBadge');
    const empty   = document.getElementById('cartEmpty');
    const items   = document.getElementById('cartItems');
    const total   = document.getElementById('cartTotal');

    if (badge)  badge.textContent = cart.item_count;
    if (total)  total.textContent = formatMoney(cart.total_price);
    if (!items) return;

    if (cart.item_count === 0) {
      if (empty) empty.style.display = '';
      items.innerHTML = '';
      return;
    }
    if (empty) empty.style.display = 'none';
    items.innerHTML = cart.items.map(item => `
      <div class="cart-item">
        <div class="ci-icon">
          ${item.image
            ? `<img src="${item.image}" style="width:100%;height:100%;object-fit:cover;border-radius:.6rem;" />`
            : '✨'}
        </div>
        <div class="ci-info">
          <div class="ci-name">${item.product_title}</div>
          <div class="ci-price">${formatMoney(item.price)} × ${item.quantity}</div>
        </div>
        <button class="ci-remove" onclick="MJM.removeItem(${item.variant_id})">✕</button>
      </div>
    `).join('');
  }

  function addToCart(variantId, name, icon, price) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
    .then(r => r.json())
    .then(() => {
      showToast(icon + ' Added to cart');
      openCart();
    })
    .catch(() => showToast('Could not add to cart'));
  }

  function removeItem(variantId) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 0 })
    })
    .then(r => r.json())
    .then(renderCart)
    .catch(console.error);
  }

  /* ── TOAST ── */
  let toastTimer;
  function showToast(msg) {
    const t = document.getElementById('toast');
    if (!t) return;
    t.textContent = msg;
    t.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => t.classList.remove('show'), 2800);
  }

  /* ── MONEY FORMAT ── */
  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  /* ── INIT ── */
  document.addEventListener('DOMContentLoaded', () => {
    initStarfield();
    fetchCart();
  });



  /* ── PRODUCT INTAKE FORM → AJAX add (keeps petition properties) ── */
  function initProductForm() {
    var form = document.getElementById('product-form');
    if (!form) return;
    form.addEventListener('submit', function(e){
      e.preventDefault();
      var btn = form.querySelector('button[type=submit]');
      var original = btn ? btn.innerHTML : '';
      if (btn) { btn.disabled = true; btn.innerHTML = 'Preparing your petition…'; }
      var bump = document.getElementById('orderBump');
      var bumpOn = bump && document.getElementById('orderBumpCheck') && document.getElementById('orderBumpCheck').checked;
      var bumpQ = bumpOn ? (document.getElementById('orderBumpQuestion') || {}).value || '' : '';
      if (bumpOn && !bumpQ.trim()) {
        if (btn) { btn.disabled = false; btn.innerHTML = original; }
        var qf = document.getElementById('orderBumpQuestion'); if (qf) { qf.focus(); qf.setCustomValidity('Please type your yes-or-no question'); qf.reportValidity(); qf.setCustomValidity(''); }
        return;
      }
      fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { 'Accept': 'application/json' } })
        .then(function(r){ if (!r.ok) { throw new Error('add failed'); } return r.json(); })
        .then(function(){
          if (!bumpOn) return;
          return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [{ id: parseInt(bump.getAttribute('data-variant'), 10), quantity: 1, properties: { 'Your Question': bumpQ.trim(), 'Added with': document.title } }] }) })
            .then(function(r){ if (!r.ok) { throw new Error('bump failed'); } return r.json(); });
        })
        .then(function(){
          /* One item, digital delivery: skip the cart drawer and go straight to checkout */
          if (btn) { btn.innerHTML = 'Taking you to secure checkout…'; }
          showToast('✦ Petition received — opening secure checkout');
          window.location.href = '/checkout';
        })
        .catch(function(){
          if (btn) { btn.disabled = false; btn.innerHTML = original; }
          showToast('Could not add — please try again');
        });
    });
  }

  document.addEventListener('DOMContentLoaded', initProductForm);
  document.addEventListener('change', function (e) {
    if (e.target && e.target.id === 'orderBumpCheck') {
      var q = document.getElementById('orderBumpQ'); if (q) { q.hidden = !e.target.checked; if (e.target.checked) { var i = document.getElementById('orderBumpQuestion'); if (i) i.focus(); } }
    }
  });

  /* ── MOBILE NAV ── */
  function setNav(open) {
    var m = document.getElementById('mobileMenu');
    var b = document.getElementById('navToggle');
    if (!m) return;
    m.classList.toggle('open', open);
    if (b) {
      b.classList.toggle('is-open', open);
      b.setAttribute('aria-expanded', open ? 'true' : 'false');
      b.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    }
  }
  function toggleNav() {
    var m = document.getElementById('mobileMenu');
    if (m) setNav(!m.classList.contains('open'));
  }
  document.addEventListener('click', function (e) {
    var m = document.getElementById('mobileMenu');
    if (!m || !m.classList.contains('open')) return;
    if (e.target.closest('#mobileMenu a')) { setNav(false); return; }
    if (!e.target.closest('#mobileMenu') && !e.target.closest('#navToggle')) setNav(false);
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') setNav(false); });
  window.addEventListener('resize', function () { if (window.innerWidth > 1024) setNav(false); });

  /* — DARK MODE — */
  function applyTheme(theme) {
  if (theme === 'dark') {
  document.documentElement.removeAttribute('data-theme');
  } else {
  document.documentElement.removeAttribute('data-theme');
  }
  }
  function toggleTheme() {
    var isDark = document.documentElement.getAttribute('data-theme') === 'dark';
    var next = isDark ? 'light' : 'dark';
    applyTheme(next);
    try { localStorage.setItem('mjm-theme', next); } catch (e) {}
    }

  return { openCart, closeCart, addToCart, removeItem, showToast, toggleNav, toggleTheme };
})();
/* ── Delivery speed picker (variant selection + live price) ── */
(function () {
  function initDeliveryPicker() {
    var radios = document.querySelectorAll('input[name="delivery-speed"]');
    if (!radios.length) return;
    var idField = document.getElementById('variant-id');
    var priceEl = document.getElementById('pdp-price-now');
    var buyBtn  = document.getElementById('pdp-buy-btn');
    var barPrice = document.querySelector('.mobile-buy-bar .mb-now');
    var buyLabel = buyBtn ? buyBtn.textContent.split('—')[0].trim() : '';

    radios.forEach(function (r) {
      r.addEventListener('change', function () {
        if (!r.checked) return;
        if (idField) idField.value = r.value;
        var p = r.getAttribute('data-price');
        if (priceEl) priceEl.textContent = p;
        if (buyBtn && buyLabel) buyBtn.textContent = buyLabel + ' — ' + p;
        if (barPrice) barPrice.textContent = p;
        document.querySelectorAll('.delivery-option').forEach(function (l) {
          l.classList.remove('is-selected');
        });
        var lbl = r.closest('.delivery-option');
        if (lbl) lbl.classList.add('is-selected');
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDeliveryPicker);
  } else {
    initDeliveryPicker();
  }
})();

/* ── Mobile sticky Add to Cart (749px and under) ──
   Hidden while the main Add to Cart button is on screen; slides in once the
   visitor has scrolled and that button is out of view. */
(function () {
  function initStickyBuy() {
    var bar = document.querySelector('.mobile-buy-bar');
    var main = document.getElementById('pdp-buy-btn');
    if (!bar || !main || !('IntersectionObserver' in window)) return;
    var mq = window.matchMedia('(max-width: 749px)');
    var mainVisible = false;
    var btn = bar.querySelector('button');
    function update() {
      var show = mq.matches && !mainVisible && window.scrollY > 200;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      if (btn) { btn.tabIndex = show ? 0 : -1; }
    }
    new IntersectionObserver(function (entries) {
      mainVisible = entries[0].isIntersecting;
      update();
    }).observe(main);
    window.addEventListener('scroll', update, { passive: true });
    if (mq.addEventListener) { mq.addEventListener('change', update); }
    update();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyBuy);
  } else {
    initStickyBuy();
  }
})();
